import { Container } from "@mui/material";
import React from "react";

const ChangeLog = () => {
  return <Container>ChangeLog</Container>;
};

export default ChangeLog;
